// extracted by mini-css-extract-plugin
export default {"root":"sAn83Q","page":"PQjE5L","navigation":"Z1idlK"};